import { useEvent, useStoreMap } from 'effector-react'
import { $historyPaths, addHistoryPath, popHistoryPath } from 'src/features/history-paths/model'

export const useAddHistoryPath = () => useEvent(addHistoryPath)
export const usePopHistoryPath = () => useEvent(popHistoryPath)
export const useIsHistoryPath = () => useStoreMap($historyPaths, (paths) => paths.length > 0)
